// Exporting the checkSubscription function
export const checkSubscription = (user) => {
  // Check if user exists and has userPlan property
  if (!user || !user.userPlan) {
    return false;
  }

  const normalizedPlan = String(user.userPlan).trim().toLowerCase().replaceAll('_', '-');

  // Define an array of valid subscription plans
  const subscriptionPlans = [
    'calcium-monthly',
    'calcium-six-month',
    'calcium-quarterly',
    'calcium-annually',
    'calcium-plus'
  ];

  // Check if the user's plan is one of the subscription plans
  return subscriptionPlans.includes(normalizedPlan);
}